import React, { useMemo } from "react";
import { getPassportPrepareOptions } from "../config/passportPhotoMakerFeatures";
import "./PassportDeliverPanel.css";

/**
 * Download step: prepare print format, then download / print.
 * Actions live in the modal footer.
 */
const PassportDeliverPanel = ({
  prepareOptionId = "single",
  photoWidthMm = 35,
  photoHeightMm = 45,
  onPrepareOptionChange = () => {},
  onBack = () => {},
  busy = false,
}) => {
  const options = useMemo(
    () => getPassportPrepareOptions({ photoWidthMm, photoHeightMm }),
    [photoWidthMm, photoHeightMm]
  );

  return (
    <div className="appm-deliver">
      <section className="appm-deliver__section">
        <div className="appm-deliver__header">
          <p className="appm-deliver__heading">Prepare</p>
          <p className="appm-deliver__sub">
            Choose format, then download or print from the footer.
          </p>
        </div>

        <div
          className="appm-deliver__formats"
          role="radiogroup"
          aria-label="Print format"
        >
          {options.map((item) => {
            const isSelected = prepareOptionId === item.id;
            const copiesLabel =
              item.copies === 1 ? "1 copy" : `${item.copies} copies`;
            return (
              <button
                key={item.id}
                type="button"
                role="radio"
                aria-checked={isSelected}
                className={`appm-deliver__format${isSelected ? " is-selected" : ""}`}
                disabled={busy}
                onClick={() => onPrepareOptionChange(item.id)}
              >
                <span className="appm-deliver__format-thumb" aria-hidden="true">
                  <span
                    className={`appm-deliver__format-paper${
                      item.thumb === "single"
                        ? " appm-deliver__format-paper--single"
                        : ""
                    }`}
                    style={{
                      aspectRatio: `${item.iconWidthMm || 1} / ${item.iconHeightMm || 1}`,
                    }}
                  >
                    {item.thumb === "single" ? (
                      <span className="appm-deliver__format-photo" />
                    ) : (
                      <span
                        className="appm-deliver__format-photos"
                        style={{
                          gridTemplateColumns: `repeat(${Math.min(item.cols || 1, 4)}, minmax(0, 1fr))`,
                          gridTemplateRows: `repeat(${Math.min(item.rows || 1, 4)}, minmax(0, 1fr))`,
                        }}
                      >
                        {Array.from(
                          {
                            length: Math.min(
                              (Math.min(item.cols || 1, 4) *
                                Math.min(item.rows || 1, 4)) ||
                                1,
                              12
                            ),
                          },
                          (_, i) => (
                            <span key={i} className="appm-deliver__format-photo" />
                          )
                        )}
                      </span>
                    )}
                  </span>
                </span>
                <span className="appm-deliver__format-text">
                  <span className="appm-deliver__format-label">{item.label}</span>
                  {item.sizeLabel ? (
                    <span className="appm-deliver__format-size">{item.sizeLabel}</span>
                  ) : null}
                  <span className="appm-deliver__format-copies">{copiesLabel}</span>
                </span>
                <span
                  className={`appm-deliver__check${isSelected ? " is-checked" : ""}`}
                  aria-hidden="true"
                >
                  {isSelected ? "✓" : null}
                </span>
              </button>
            );
          })}
        </div>
      </section>

      <button
        type="button"
        className="appm-deliver__link"
        onClick={onBack}
        disabled={busy}
      >
        Back to photo settings
      </button>
    </div>
  );
};

export default PassportDeliverPanel;
